import { createClient } from '@supabase/supabase-js'

interface InsertResult {
  mode: 'audio_error' | 'incorrect_label'
  data: any | null
  //TODO: better typing
}

const useReportBug = () => {
  const reportBug = async (props: InsertResult) => {
    try {
      //create supabase connection
      const supabase = createClient(
        process.env.REACT_APP_SUPABASE_URL as string,
        process.env.REACT_APP_SUPABASE_API as string
      )

      let insertData = {}
      let tableName = ''
      // check type
      if (props.mode === 'audio_error') {
        tableName = 'audio_errors'
        insertData = {
          filename: props.data.filename,
        }
      } else if (props.mode === 'incorrect_label') {
        tableName = 'incorrect_labels'
        insertData = {
          current_language: props.data.current_language,
          guessed_language: props.data?.current_guess,
          filename: props.data.filename,
        }
      }

      // insert data
      if (tableName) {
        const { data: insertedData, error } = await supabase
          .from(tableName)
          .insert(insertData)

        if (error) {
          //TODO: better Error handling
          console.log(error)
        } else {
          return insertedData
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  return { reportBug }
}

export default useReportBug
